import React, { FC } from 'react';
import { ArrowRight3Outline } from 'ui/components/Icon';

import { CollapseProps } from './types';

import { StyledCollapse } from './styled';

export const Collapse: FC<CollapseProps> = ({ size, ...props }) => (
  <StyledCollapse
    expandIcon={({ isActive }) => (
      <ArrowRight3Outline className={isActive ? 'active' : undefined} />
    )}
    className={size}
    {...props}
  />
);

Collapse.defaultProps = {
  size: 'middle',
};
